import React from 'react';
import TagsInputWUT from '../../inputs/tags-input/tags-input-wut';
import { useFieldAttributes } from '../../services/field-attributes';
import { FieldDescriptionWUT } from '../field-description/field-description-wut';
import { FieldErrorWUT } from '../field-error/field-error-wut';
import { FieldLabelWUT } from '../field-label/field-label-wut';
import { NUMBER_OF_COLUMNS } from '../options-layout/options-layout-constants';
import { Widget } from '../widget/widget';
export const TagsFieldWUT = _ref => {
  let {
    id,
    target,
    label,
    hideLabel = false,
    required = false,
    description,
    error,
    addOther,
    addOtherLabel,
    addOtherPlaceholder,
    value = null,
    hasError = false,
    errorMessage,
    options,
    numberOfColumns = NUMBER_OF_COLUMNS.FREE_FLOW,
    otherInputCharacterLimit,
    disabled = false,
    onChange,
    onFocus,
    onBlur,
    additionalInfo,
    FieldLayout,
    requiredIndicatorType,
    requiredIndicatorPlacement,
    widgetHtml,
    widgetEnabled
  } = _ref;
  const {
    labelId,
    inputId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id, error, description);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(FieldLabelWUT, {
      labelId: labelId,
      htmlFor: inputId,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: requiredIndicatorType,
      requiredIndicatorPlacement: requiredIndicatorPlacement
    }),
    renderInput: () => widgetHtml && widgetEnabled ? /*#__PURE__*/React.createElement(Widget, {
      fieldId: id,
      widgetHtml: widgetHtml,
      onChange: onChange,
      value: value
    }) : /*#__PURE__*/React.createElement(TagsInputWUT, {
      addOtherPlaceholder: addOtherPlaceholder,
      otherInputCharacterLimit: otherInputCharacterLimit,
      disabled: disabled,
      onFocus: onFocus,
      onBlur: onBlur,
      addOther: addOther,
      addOtherLabel: addOtherLabel,
      value: value,
      options: options,
      onChange: onChange,
      numberOfColumns: numberOfColumns,
      ariaDescribedBy: ariaDescribedBy,
      inputId: inputId,
      labelId: labelId,
      required: required,
      hasError: hasError,
      label: label,
      id: id
    }),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldErrorWUT, {
      target: target,
      hasError: hasError,
      errorMessage: errorMessage,
      id: errorId
    }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }), additionalInfo)
  });
};
//# sourceMappingURL=tags-field-wut.js.map